<template>
  <div class="agreementDialog">
    <div class="agreementDialog__content">
      <div class="close" @click="handleClose"></div>
      <h1>{{agreementTitle}}</h1>
      <div id="agreement"  class="agreement_content">
        <div class="agreement__text" v-if="!globalConfig.agreementContent">
          <p>本人自愿参与活动考试，愿意在活动中自觉遵守各项规定，现郑重承诺：</p>
          <br>
          <p>一、诚信考试，自觉服从监考员等工作人员管理，不得以任何理由妨碍监考员等考试工作人员履行职责，不得扰乱考试工作的秩序。</p>
          <br>
          <p>二、凭学员编号和登录密码等有效身份证件，按规定时间登录网站参加竞赛。</p>
          <br>
          <!-- <p>三、考生登录网站后，按照要求进行登录作答.作答期间严禁使用U盘，硬盘，手机，pad等移动设备；严禁考试违纪，作弊等行为（如打开其他与考试无关的网页，或其他人员旁边进行指导等）；涉及试题内容的问题，考生自行理解，监考员不予解释，特殊情况需通过腾讯会议室向监考老师报备。</p>
          <p>四、考试过程中，如出现去厕所等情况，务必示意监考老师同意后方可离开座位。离开监考区域时间不得超过10分钟，否则成绩视为无效。</p>
          <p>五、选择题部分提交后将无法修改，考试系统将按照提交答案进行自动阅卷，创作（应用）部分则按最后一次提交保存为准。</p>
          <p>六、考试期间保持安静，不得与家人或其它人进行交流。</p> -->
          <p>三、如不遵守考场纪律，不服从工作人员管理，有违纪、作弊等行为的，将按照 <strong> 无成绩记录</strong>。</p>
          <br>
          <p><strong>本人已认真阅读上述考场规则，并保证严格遵守活动纪律，共同维护考试秩序</strong>。</p>
        </div>
        <pre v-else v-html="globalConfig.agreementContent"></pre>
        
    </div>
    <div class="agreementDialog__footer">
      <div class="reg__agree">
        <label class="reg__agree__label">
          <input id="checkbox" type="checkbox" checked="checked" v-model="isAgree"><i>✓</i>
          <label for="checkbox">已经阅读并同意</label>
        </label>
        <span
          class="reg__agree__active"
        >
        《 {{agreementTitle}} 》
        </span>
      </div>
      <div class="agreementDialog__agreement" >
        <button :disabled='!isAgree' :class="['agreement-button',{'active':isAgree}]" @click="submit">
          {{isTimingType}}
        </button>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'Agreement',

  props: {
    active: {
      type: Boolean,
      default: false,
    },
    timingType:{
      type: Number,
      default:0
    }
  },
  data(){
    return{
      isAgree:true,
      isTimingType: this.timingType === 0 ? '开始' : '开始计时'
    }
  },
  computed: {
    ...mapState({
        globalConfig: state => state.router.globalConfig,
    }),
    visible: {
      get() {
        return this.active;
      },
      set(newVal) {
        this.$emit('update:active', newVal);
      },
    },
    agreementTitle(){
      if(this.globalConfig.agreementTitle) return this.globalConfig.agreementTitle;
      return '赛前承诺书'
    }
  },
  methods: {
    handleClose() {
      this.$emit('close',this.active);
    },
    submit(){
      this.$emit('onSuccess',this.active)
    }
  },
};
</script>

<style lang="less" scoped>
.agreementDialog {
  position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left:0;
	z-index: 99;
	background-color:rgba(12,12,12,.616);
  color: #333;
  cursor: default;
  &__content{
    position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
    width: 564px;
    padding: 0 10px;
    height: 552px;
    text-align: left;
    display: flex;
    flex-direction: column;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 8px 0px rgba(0,0,0,0.3);
    border-radius:6px;
    box-sizing: border-box;
    
  }
  .agreement__text{
    padding: 0 24px 20px;
  }
  pre{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;
    line-height: 22px;
    white-space:pre-wrap;
    padding: 0 24px 20px;
    margin: 0;
  }
  ::-webkit-scrollbar {
    display: block;
    width: 6px;
    position: absolute;
    right: 10px;
  } /* 整体样式 */
  ::-webkit-scrollbar-track {
  } /* 轨道 */
  ::-webkit-scrollbar-thumb {
    width: 6px;
    height: 154px;
    background: rgba(192, 192, 192, 1);
    border-radius: 4px;
  } /* 滑块 */
  ::-webkit-scrollbar-track-piece {
    background-color: none;
  } /* 不包含滑块的轨道区 */
  #agreement {
    height: 356px;
    overflow-y: overlay;
    // padding-right: 5px;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 20px 10px 30px 35px;
    box-sizing: border-box;
    height: 0;
    flex: 1 1 auto;
  }
  p {
    width: 100%;
    overflow-wrap: break-word;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;
    line-height: 22px;

    &.indent {
      text-indent: 2em;
    }
  }
  .second {
    text-indent: 1em;
  }
  .third {
    text-indent: 2em;
  }
  h1 {
    height: 33px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 33px;
    text-align: center;
    margin-block-start: 20px;
    margin-block-end: 20px;
  }
  h2 {
    // font-size:20px;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 21px;
  }
  &__footer{
    padding:20px 0 28px;
    background: #fff;
    text-align: center;
    font-size: 14px;
    color:#333;
    box-shadow:0px 2px 7px 0px rgba(173,173,173,0.5);
    position: absolute;
    bottom:0;
    left:0;
    width: 100%;
    .reg__agree__label{
      cursor: pointer;
    }
    .reg__agree__active{
      color: rgba(241, 197, 32, 1);
      font-weight: 500;
    }
    .agreement-button{
      padding:0 56px;
      height:40px;
      line-height: 36px;
      color:#fff;
      margin-top:10px;
      border:1px solid #e0b45f;
      background: #BEBEBE;
      border:2px solid #A2A2A2 ;
      border-radius: 20px;
      outline: none;
      cursor: pointer;
      &.active{
        background: #F1C520;
        border:2px solid #E0B45F ;
        color: #000;
      }
      &:hover {
        color: #fff;
      }
    }
  }
}
.close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 18px;
  height: 18px;
  background: url('../assets/competition_close.png') no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
label i {
    font-size: 12px;
    font-style: normal;
    display: inline-block;
    width: 14px;
    height: 14px;
    text-align: center;
    line-height: 14px;
    color: #fff;
    vertical-align: middle;
    margin: -2px 4px 1px 0px;
    border: 1px solid #BABABA;
    border-radius: 50%;
  }
  input[type="checkbox"],
  input[type="radio"] {
      display: none;
  }
  input[type="radio"]+ i {
      border-radius: 7px;
  }
  input[type="checkbox"]:checked+ i,
  input[type="radio"]:checked+ i {
      background: #E0B45F;
      border-color:#E0B45F ;
  }
  input[type="checkbox"]:disabled+ i,
  input[type="radio"]:disabled+ i {
      border-color:#E0B45F ;
  }
  input[type="checkbox"]:checked:disabled+ i,
  input[type="radio"]:checked:disabled+ i {
      border-color:#E0B45F ;
  }
</style>
